import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AllExports } from '../../shared/models/generated/ziroModels';
import { BreadcrumbsService } from '../../shared/breadcrumbs/breadcrumbs.service';
import { ActivatedRoute } from '@angular/router';
import { MigrationsAssessmentsContext } from '../services/migrations-assessments.context';

@Component({
  selector: 'ziro-migrations-create',
  templateUrl: 'migrations-create.component.html',
  standalone: false,
  styleUrl: '../migrations.component.scss',
})
export class MigrationsCreateComponent implements OnInit, OnDestroy {
  private _migrationsAssessmentsContext = inject(MigrationsAssessmentsContext);
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _route = inject(ActivatedRoute);

  isLoading = true;
  allAssessments: AllExports;

  private _tenantId: string;
  private _subscription = new Subscription();

  ngOnInit(): void {
    this._tenantId = this._route.snapshot.paramMap.get('tenantId');
    const sub = this._migrationsAssessmentsContext.state$.subscribe((assessments) => {
      this.allAssessments = assessments;
      this.isLoading = false;
    });
    this._subscription.add(sub);

    this._breadcrumbsService.updateBreadcrumbs([
      { label: 'tkey;migrations.title', routerLink: true, url: `/migrations/tenants/${this._tenantId}` },
      { label: 'tkey;migrations.create.title' },
    ]);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
